import React from 'react';

import { ReactComponent as NewTabIcon } from '@pkg/assets/icons/v1/external-link.svg';
import { Button, ChipColor, ChipMember } from '@pkg/components';
import { useBreakpoints } from '@pkg/hooks';

import { useProfileNotificationsStore } from '@app/store/zustand/profile-page/useProfileNotificationsStore';

import { InfoModal } from './InfoModal';
import BackgroundImageSrc from './background.png';

import { Buttons, Text, Title, YatChip, YatLabel, YatWrapper } from './styles';

export const FreeyatModal = () => {
    const { isMobile } = useBreakpoints();
    const { selectedYat, openFreeYatModal, setOpenFreeYatModal } = useProfileNotificationsStore();

    const onClose = () => {
        setOpenFreeYatModal(false);
    };

    return (
        <InfoModal
            show={openFreeYatModal}
            onClose={onClose}
            bannerContent={
                <>
                    <YatWrapper>
                        {selectedYat && (
                            <YatChip>
                                <ChipMember yat={selectedYat} color={ChipColor.Transparent} size={'large'} />
                            </YatChip>
                        )}
                        <YatLabel>Free Yat</YatLabel>
                    </YatWrapper>

                    <img src={BackgroundImageSrc} alt="" />
                </>
            }
            bodyContent={
                <>
                    <Title>
                        <span>🎉</span> You’ve got a Free Yat <span>🎉</span>
                    </Title>
                    <Text>
                        <div>
                            We like you, and there’s no better way to say that than with a freebie! A free Yat let’s you
                            get a taste of the good stuff without having to spend a dime.{' '}
                        </div>

                        <div>
                            While you can’t do it all with a free Yat, there’s enough in there for you to explore. Go
                            on, take it for a spin.
                        </div>
                    </Text>
                    <Buttons>
                        <Button
                            to="https://support.y.at/getting-started/yat-profile/what-is-my-free-yat-what-can-i-do-with-it"
                            size={isMobile ? 'small' : 'medium50'}
                            variant="highlight"
                            onClick={onClose}
                            startIcon={<NewTabIcon />}
                            target="_blank"
                        >
                            Learn more
                        </Button>
                    </Buttons>
                </>
            }
        />
    );
};
